import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { Route, Routes } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./constants/firebase/firebaseConfig";
import { Bounce, toast } from "react-toastify"; // Import scss
import Message from "./components/Common/MessageNotification";
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import Fack Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { setNotificaiton } from "./store/slices/authSlice";

// Activating fake backend
fakeBackend();

const App = (props) => {
  const layoutType = useSelector((state) => state.settings.layoutType);
  const dispatch = useDispatch();
  function getLayout() {
    let layoutCls = VerticalLayout;

    switch (layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  async function requestPermission() {
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAP_ID,
      });
      console.log("token", token);
      localStorage.setItem("fcm", token);
      //We can send token to server
    } else if (permission === "denied") {
    }
  }
  onMessage(messaging, (payload) => {
    dispatch(setNotificaiton(true));
    toast(<Message notification={payload.notification} />);
    // toast(payload.notification)
  });
  useEffect(() => {
    requestPermission();
  }, []);

  return (
    <React.Fragment>
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            isAuthProtected={false}
          />
        ))}

        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
            key={idx}
            isAuthProtected={true}
            exact
          />
        ))}
      </Routes>
    </React.Fragment>
  );
};

// App.propTypes = {
//   layout: PropTypes.any,
// }

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

// export default connect(mapStateToProps, null)(App);
export default App;
